/*
 * @Author: wuhao
 * @Date: 2019-07-04 09:19:59
 * @LastEditors: lisf
 * @LastEditTime: 2021-03-29 17:53:51
 * @Description: API
 */
/* eslint-disable prefer-promise-reject-errors */
import axios from 'axios'
import store from '@/unit/storage'
import { Message } from 'element-ui'
import errorIntercept from '@/api/errorMessage'

// 创建axios实例
const service = axios.create({
    withCredentials: false,
    // timeout: 10000000 // 请求超时时间
    timeout: 60000 // 请求超时时间
})

// request 拦截器(请求之前的操作)
service.interceptors.request.use(
    config => {
    // vuex.commit('setReqLoading', true)
        const token = store.get('token')
        //   const token =
        // 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIwMDAiLCJ1c2VyX21ldGFkYXRhIjp7ImNsaWVudHR5cGUiOiIwIiwicm9sZSI6Iua3seWcs-W-gCIsIm5hbWUiOiJkZCIsInVzZXJpZCI6Imhhbmhhb21haSJ9LCJpZCI6Imhhbmhhb21haSIsImV4cCI6MTYxNTYxNTI4MiwiZW1haWwiOiIiLCJhcHBfbWV0YWRhdGEiOm51bGx9.4UvDTUftxPzDZcaQomUPG5w1Eu0k4Ya60fbBMzsg6WU'
        if (token) config.headers['token'] = token
        return config
    },
    error => {
    // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        console.log('err' + error) // for debug
        if (!errorIntercept(error.response.data)) {
            Message({
                message: '接口错误',
                type: 'error'
            })
        }
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js